(function ($) {
  'use strict';

  const BASE_IMG = 'https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/tenban/';
  const BG_IMG = 'https://www.rakuten.ne.jp/gold/arne/size_order/images/';
  const EXISTING_URL = 'https://interior-arne.com/products/';

  const ITEM_DEFAULT = '10101952';
  //const ITEM_GLANDE = '10102010';
  const SHOP_BID = '203706';
  const VARIANT_DEFAULT = '555a00028';
  const VARIANT_GLANDE = '555a00029';
  const VARIANT_AINO = '555a00049';

  const LIMITS = {
    cir: {
      haba: { min: 60, max: 90, label: '直径' }
    },
    sq: {
      haba: { min: 40, max: 180, label: '幅' },
      depth: { min: 40, max: 90, label: '奥行' }
    },
    rsq: {
      haba: { min: 40, max: 180, label: '幅' },
      depth: { min: 40, max: 90, label: '奥行' }
    }
  };

  const SHAPE_TEXT = {
    cir: '円形',
    sq: 'スクエア',
    rsq: '角丸スクエア'
  };

  const SHAPE_INFO = {
    cir: '直径60〜90cmまで1cm単位でオーダー可能です。<br><font style="color: #d10000">※パステルカラーainoは作成不可</font>',
    sq: '幅40〜180cm、奥行40〜90cmまで1cm単位でオーダー可能です。',
    rsq: '幅40〜180cm、奥行40〜90cmまで1cm単位でオーダー可能です。<br><font style="color: #d10000">※パステルカラーainoは作成不可</font>'
  };

  const MATERIAL_TEXT = {
    wood: '材質：デルナチュレ化粧合板',
    aino: 'aino材質を選択してください',
    mela: '材質：メラミン樹脂化粧合板',
    glande3: '材質：MDF合板、天然木突板(セラウッド塗装)',
    glande2: '材質：MDF合板、天然木突板(セラウッド塗装)'
  };

  const AINO_TEXT = {
    reasonable: '材質：プリント化粧合板',
    premium: '材質：メラミン樹脂化粧合板'
  };

  const COLOR_ROW_BASE = {
    A: 0,
    B: 13,
    C: 26,
    D: 39,
    E: 52
  };

  const COLOR_BAND = {
    A: ['wood', 'aino-reasonable'],
    B: ['aino-premium', 'mela_nail', 'mela_bk', 'mela_bp'],
    C: ['mela_mb', 'mela_gs', 'mela_ww'],
    D: ['glande3'],
    E: ['glande2']
  };

  const HOLE_POSITIONS = {
    cir: ['中央'],
    sq: ['左奥', '左中央', '左手前', '中央奥', '中央', '中央手前', '右奥', '右中央', '右手前'],
    rsq: ['左奥', '左中央', '左手前', '中央奥', '中央', '中央手前', '右奥', '右中央', '右手前']
  };

  let priceTable = null;
  let existingList = null;
  let colorSlidesCache = null;

  function onlyDigits(v) {
    return String(v == null ? '' : v).replace(/[^\d]/g, '');
  }

  function readInt(id) {
    const el = document.getElementById(id);
    if (!el) return { el: null, val: NaN, isEmpty: true };
    const cleaned = onlyDigits(el.value);
    if (el.value !== cleaned) el.value = cleaned;
    const isEmpty = cleaned === '';
    const val = isEmpty ? NaN : parseInt(cleaned, 10);
    return { el: el, val: val, isEmpty: isEmpty };
  }

  function ceil5(n) {
    return Math.ceil(n / 5) * 5;
  }

  function formatYen(n) {
    const s = String(n == null ? '' : n).replace(/[^\d]/g, '');
    if (!s) return '';
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '円';
  }

  function getShape() {
    const el = document.querySelector('input[name="shape"]:checked');
    if (!el) return 'sq';
    if (el.id === 'shape-cir') return 'cir';
    if (el.id === 'shape-rsq') return 'rsq';
    return 'sq';
  }

  function getShapeText() {
    return SHAPE_TEXT[getShape()] || '';
  }

  function getSelectedColorInput() {
    return document.querySelector('input[name="colortype1"]:checked');
  }

  function getSelectedMaterialType() {
    return String($(getSelectedColorInput()).data('type') || '').toLowerCase();
  }

  function getSelectedColorId() {
    const el = getSelectedColorInput();
    return el ? String(el.id || '') : '';
  }

function getSelectedColorName() {
  const el = getSelectedColorInput();
  if (!el) return '';

  const baseName = String(el.value || '');
  const type = String($(el).data('type') || '').toLowerCase();

  if (type === 'aino') {
    return baseName + (getAinoMaterialKey() === 'premium' ? '(メラミン)' : '(プリント)');
  }

  return baseName;
}

  function getAinoMaterialKey() {
    if ($('#premium').prop('checked')) return 'premium';
    return 'reasonable';
  }

  function getBandToken() {
    const type = getSelectedMaterialType();
    const colorId = getSelectedColorId();
    if (type === 'wood') return 'wood';
    if (type === 'aino') return 'aino-' + getAinoMaterialKey();
    if (type === 'mela') return colorId;
    if (type === 'glande3') return 'glande3';
    if (type === 'glande2') return 'glande2';
    return '';
  }

  function getBandByColor() {
    const token = getBandToken();
    if (!token) return null;
    if (COLOR_BAND.A.indexOf(token) !== -1) return 'A';
    if (COLOR_BAND.B.indexOf(token) !== -1) return 'B';
    if (COLOR_BAND.C.indexOf(token) !== -1) return 'C';
    if (COLOR_BAND.D.indexOf(token) !== -1) return 'D';
    if (COLOR_BAND.E.indexOf(token) !== -1) return 'E';
    return null;
  }

  function isAinoSelected() {
    return getSelectedMaterialType() === 'aino';
  }

  function isGlandeSelected() {
    const type = getSelectedMaterialType();
    return type === 'glande2' || type === 'glande3';
  }

  function getItemConfig() {
    if (isAinoSelected()) {
      return {
        itemId: ITEM_DEFAULT,
        variantId: VARIANT_AINO
      };
    }

    if (isGlandeSelected()) {
      return {
        itemId: ITEM_DEFAULT,
        variantId: VARIANT_GLANDE
      };
    }

    return {
      itemId: ITEM_DEFAULT,
      variantId: VARIANT_DEFAULT
    };
  }

  function getColorKeyForExisting() {
    const type = getSelectedMaterialType();
    if (type === 'aino') {
      return getAinoMaterialKey() === 'premium' ? '__NO_EXISTING__' : 'aino';
    }
    if (type === 'wood') return 'wood';
    if (type === 'mela') return getSelectedColorId();
    if (type === 'glande3') return 'glande3';
    if (type === 'glande2') return 'glande2';
    return '';
  }

  function hasAnyOption() {
    return $('#op_haisen').prop('checked') || $('#op_hole').prop('checked');
  }

  function getOptionText() {
    const list = [];
    if ($('#op_haisen').prop('checked')) list.push('配線切り欠き');
    if ($('#op_hole').prop('checked')) {
      const pos = $('select[name="op_hole--position"]').val() || '';
      if (pos && pos !== '穴位置を選択') list.push('配線穴(' + pos + ')');
      else list.push('配線穴');
    }
    return list.length ? list.join('、') : 'なし';
  }

  function $sizeMsg() {
    return $('.form_size').closest('.form').find('> .msg').first();
  }

  function $orderMsg() {
    return $('.order-summary > .msg');
  }

  function setCheckoutUIEnabled(on) {
    const price = document.querySelector('.check_price');
    const cart = document.querySelector('.cart--btn');
    if (price) price.setAttribute('style', on ? '' : 'visibility: hidden');
    if (cart) {
      if (on) cart.removeAttribute('disabled');
      else cart.setAttribute('disabled', '');
    }
  }

  function resetOrderSummary() {
    $orderMsg().empty();
    $('.check_area li span').text('');
    $('.check_price').empty().attr('style', 'visibility: hidden');
    setCheckoutUIEnabled(false);
    $('#units').val('');
    for (let i = 1; i <= 7; i++) {
      $('#choice' + i).val('');
    }
  }

  function removeSizeError(key) {
    const cls = 'note-size-error-' + key;
    $sizeMsg().find('.' + cls).remove();
  }

  function setSizeError(key, text) {
    const cls = 'note-size-error note-size-error-' + key;
    const $msg = $sizeMsg();
    let $p = $msg.find('.note-size-error-' + key);
    if (!$p.length) {
      $p = $('<p>').addClass(cls);
      $msg.append($p);
    }
    $p.text(text);
  }

  function validateSizeFieldForBlur(key) {
    const shape = getShape();
    const lim = LIMITS[shape][key];
    if (!lim) {
      removeSizeError(key);
      return;
    }
    const rec = readInt(key);
    if (rec.isEmpty) {
      removeSizeError(key);
      return;
    }
    if (!Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
      setSizeError(key, lim.label + 'は' + lim.min + '〜' + lim.max + 'cmの範囲で入力してください（現在：' + (Number.isFinite(rec.val) ? rec.val : '') + 'cm）');
      return;
    }
    removeSizeError(key);
  }

  function buildJumpSizeErrors() {
    const shape = getShape();
    const errors = [];
    ['haba', 'depth'].forEach(function (key) {
      const lim = LIMITS[shape][key];
      if (!lim) return;
      const rec = readInt(key);
      if (rec.isEmpty) {
        errors.push(lim.label + 'を入力してください');
      } else if (!Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
        errors.push(lim.label + 'は' + lim.min + '〜' + lim.max + 'cmの範囲で入力してください（現在：' + rec.val + 'cm）');
      }
    });
    return errors;
  }

  function loadPriceOnce() {
    if (Array.isArray(priceTable)) return $.Deferred().resolve(priceTable).promise();
    return $.ajax({ url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/tenban_price.csv", dataType: 'text' }).then(function (text) {
      priceTable = $.csv.toArrays(text).map(function (row) {
        return row.map(function (v) {
          return parseInt(String(v).replace(/[^\d]/g, ''), 10);
        });
      });
      return priceTable;
    }).catch(function () {
      priceTable = [];
      return priceTable;
    });
  }

  function loadExistingOnce() {
    if (Array.isArray(existingList)) return $.Deferred().resolve(existingList).promise();
    return $.ajax({ url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/tenban_existing.csv", dataType: 'text' }).then(function (text) {
      existingList = $.csv.toArrays(text);
      return existingList;
    }).catch(function () {
      existingList = [];
      return existingList;
    });
  }

  function syncMaterialBubble() {
    const type = getSelectedMaterialType();
    let text = MATERIAL_TEXT[type] || '選択してください';
    if (type === 'aino') text = AINO_TEXT[getAinoMaterialKey()] || MATERIAL_TEXT.aino;
    $('.material_bubble').text(text);
  }

  function syncAinoVisibility() {
    const on = getSelectedMaterialType() === 'aino';
    $('.aino-material').toggle(on);
    if (!on) {
      $('#reasonable').prop('checked', true);
    }
  }

  function syncShapeInfo() {
    const shape = getShape();
    const label = shape === 'cir' ? '直径：' : '幅：';
    $('.form_info p').html(SHAPE_INFO[shape] || '');
    $('.form_size--txt li:first .size:first').text(label);
    if (shape === 'cir') {
      $('#depth').closest('li').hide();
      $('#depth').val('');
      removeSizeError('depth');
    } else {
      $('#depth').closest('li').show();
    }
  }

  function updatePreviewImages() {
    const shape = getShape();
    const colorId = getSelectedColorId() || 'wood_br';
    const area1 = document.querySelector('.form_size--img img[name="area1"]');
    const area2 = document.querySelector('.form_size--img img[name="area2"]');
    if (area1) area1.src = BASE_IMG + shape + '/arrow.png';
    if (area2) area2.src = BASE_IMG + shape + '/' + colorId + '.png';
    resizeFormSizeImages();
  }

function updateHoleUI() {
  const isGlande = isGlandeSelected();
  const on = $('#op_hole').prop('checked') && !isGlande;
  const shape = getShape();
  const list = HOLE_POSITIONS[shape] || [];
  const $area = $('.op_hole-area');
  const $select = $('select[name="op_hole--position"]');
  const $img = $('.op_hole--position img');

  if (isGlande) {
    $('#op_hole').prop('checked', false).prop('disabled', true).closest('li').hide();
    $area.hide();
    $select.empty().append($('<option>').val('穴位置を選択').text('穴位置を選択'));
    return;
  } else {
    $('#op_hole').prop('disabled', false).closest('li').show();
  }

  $area.toggle(on);
  if (!on) {
    $select.empty().append($('<option>').val('穴位置を選択').text('穴位置を選択'));
    return;
  }

  $img.attr('src', BASE_IMG + 'choice/shape-' + shape + '.png');
  $select.empty().append($('<option>').val('穴位置を選択').text('穴位置を選択'));
  list.forEach(function (v) {
    $select.append($('<option>').val(v).text(v));
  });
}

function resizeFormSizeImages() {
  const box = document.querySelector('.form_size--img');
  if (!box) return;

  const imgs = Array.prototype.slice.call(box.querySelectorAll('img'));
  const width = box.clientWidth;
  if (width <= 0) return;

  imgs.forEach(function (img) {
    img.style.width = width + 'px';
    img.style.height = 'auto';
  });

  requestAnimationFrame(function () {
    let maxHeight = 0;

    imgs.forEach(function (img) {
      const rectH = img.getBoundingClientRect().height || img.clientHeight || 0;
      if (rectH > maxHeight) maxHeight = rectH;
    });

    if (maxHeight > 0) {
      box.style.height = maxHeight + 'px';
    } else {
      box.style.height = '';
    }
  });
}

  function bindResizeAfterLoad() {
    const imgs = document.querySelectorAll('.form_size--img img');
    imgs.forEach(function (img) {
      img.addEventListener('load', resizeFormSizeImages);
    });
  }

  function getColorSplideRoot() {
    return document.querySelector('.splide[aria-label="カラーを選択"]') || document.getElementById('splide03') || document.querySelector('.material_area.splide');
  }

  function ensureColorSlidesCache() {
    if (colorSlidesCache) return colorSlidesCache;
    const root = getColorSplideRoot();
    if (!root) return [];
    const slides = Array.prototype.slice.call(root.querySelectorAll('.splide__slide')).filter(function (slide) {
      if (slide.classList.contains('splide__slide--clone')) return false;
      return !!slide.querySelector('input[name="colortype1"]');
    });
    colorSlidesCache = slides.map(function (slide) {
      return slide.outerHTML;
    });
    return colorSlidesCache;
  }

  function getColorSplideInstance(root) {
    if (!root || !window.__splideMap) return null;
    if (typeof window.__splideMap.get === 'function') {
      const direct = window.__splideMap.get(root);
      if (direct) return direct;
    }
    if (typeof window.__splideMap.entries === 'function') {
      const entries = Array.from(window.__splideMap.entries());
      for (let i = 0; i < entries.length; i++) {
        const key = entries[i][0];
        const val = entries[i][1];
        if (key === root) return val;
        if (key && typeof key.contains === 'function' && (key.contains(root) || root.contains(key))) {
          return val;
        }
      }
    }
    return null;
  }

  function rebuildColorSlidesDom(root, targets) {
    const list = root ? root.querySelector('.splide__list') : null;
    if (!list) return false;
    list.innerHTML = targets.join('');
    return true;
  }

  function filterColorSlidesByShape() {
    const root = getColorSplideRoot();
    const originals = ensureColorSlidesCache();
    if (!root || !originals.length) return;

    const splide = getColorSplideInstance(root);
    const shape = getShape();
    const allowAino = shape === 'sq';
    const targets = originals.filter(function (html) {
      if (allowAino) return true;
      return html.indexOf('data-type="aino"') === -1;
    });

    const currentCheckedId = getSelectedColorId();
    let rebuilt = false;

    if (splide && typeof splide.remove === 'function' && typeof splide.add === 'function') {
      try {
        const currentSlides = Array.prototype.slice.call(root.querySelectorAll('.splide__slide')).filter(function (slide) {
          if (slide.classList.contains('splide__slide--clone')) return false;
          return !!slide.querySelector('input[name="colortype1"]');
        });
        if (currentSlides.length) {
          const indexes = currentSlides.map(function (_, idx) { return idx; }).reverse();
          splide.remove(indexes);
        }
        targets.forEach(function (html) {
          splide.add(html);
        });
        if (typeof splide.refresh === 'function') splide.refresh();
        if (typeof splide.go === 'function') splide.go(0);
        rebuilt = true;
      } catch (e) {
        rebuilt = false;
      }
    }

    if (!rebuilt) {
      rebuilt = rebuildColorSlidesDom(root, targets);
      if (rebuilt && splide && typeof splide.refresh === 'function') {
        try {
          splide.refresh();
          if (typeof splide.go === 'function') splide.go(0);
        } catch (e) {}
      }
    }

    let $targetInput = currentCheckedId ? $(root).find('#' + currentCheckedId) : $();
    if (!$targetInput.length || (!allowAino && String($targetInput.data('type') || '').toLowerCase() === 'aino')) {
      $targetInput = $(root).find('input[name="colortype1"]').first();
    }
    $(root).find('input[name="colortype1"]').prop('checked', false);
    if ($targetInput.length) {
      $targetInput.prop('checked', true).trigger('change');
    }
  }

  function getPriceCell(haba, depth, band) {
    const rowBase = COLOR_ROW_BASE[band];
    if (typeof rowBase !== 'number') return NaN;

    const w5 = ceil5(haba);
    const d5 = ceil5(depth);
    const col = Math.ceil((w5 - 40) / 5);
    const row = rowBase + Math.ceil((d5 - 40) / 5);

    if (!priceTable || !priceTable[row]) return NaN;
    return priceTable[row][col];
  }

  function findExistingCode(data) {
    if (!Array.isArray(existingList) || !existingList.length) return null;
    if (data.colorKey === '__NO_EXISTING__') return null;
    if (hasAnyOption()) return null;

    for (let i = 0; i < existingList.length; i++) {
      const row = existingList[i] || [];
      const code = String(row[0] || '').trim();
      const shape = String(row[1] || '').trim().toLowerCase();
      const w = parseInt(String(row[2] || '').replace(/[^\d]/g, ''), 10);
      const d = parseInt(String(row[3] || '').replace(/[^\d]/g, ''), 10);
      const color = String(row[4] || '').trim().toLowerCase();
      if (!code) continue;
      if (shape !== String(data.shape || '').toLowerCase()) continue;
      if (w !== data.haba) continue;
      if (d !== data.depth) continue;
      if (color !== String(data.colorKey || '').toLowerCase()) continue;
      return code;
    }
    return null;
  }

  function getStoreSymbol() {
    const type = getSelectedMaterialType();
    const haba = readInt('haba').val;
    const isWide = haba >= 140;

    if (type === 'wood' || type === 'mela') return isWide ? '□' : '△';
    if (type === 'aino') return isWide ? '☆' : '●';
    if (type === 'glande2' || type === 'glande3') return isWide ? '◎' : '◆';

    return '□';
  }

  function setChoiceValues(data) {
    const choice1 = '形：' + data.shapeText + '/';
    const choice2 = '幅：' + data.haba + 'cm/';
    const choice3 = '奥行：' + data.depth + 'cm/';
    const choice4 = 'カラー：' + data.colorName + '/';
    const choice5 = 'オプション：' + data.optionText + '/';
    const choice6 = '店舗用記号：' + getStoreSymbol() + '/';
    const choice7 = '見積もり金額：' + data.price;

    $('#choice1').val(choice1);
    $('#choice2').val(choice2);
    $('#choice3').val(choice3);
    $('#choice4').val(choice4);
    $('#choice5').val(choice5);
    $('#choice6').val(choice6);
    $('#choice7').val(choice7);
    $('#units').val(String(Math.round(data.price / 100)));

    const itemConfig = getItemConfig();
    $('input[name="shop_bid"]').val(SHOP_BID);
    $('#variant_id').val(itemConfig.variantId);
  }

  function buildEncodedChoice() {
    const lines = [
      $('#choice1').val(),
      $('#choice2').val(),
      $('#choice3').val(),
      $('#choice4').val(),
      $('#choice5').val(),
      $('#choice6').val(),
      $('#choice7').val()
    ].filter(function (v) {
      return String(v || '').length > 0;
    });

    const choice = lines.join('\r\n');
    const unicodeArray = Encoding.stringToCode(choice);
    const eucArray = Encoding.convert(unicodeArray, { to: 'EUCJP', from: 'UNICODE' });
    return Encoding.urlEncode(eucArray);
  }

  function submitToRakutenCart(e) {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();

    const units = $('#units').val();
    if (!units || !$('#choice1').val() || !$('#choice7').val()) return false;

    const itemConfig = getItemConfig();
    const encodedChoice = buildEncodedChoice();
    const existingForm = document.querySelector('form[name="cart_form_ori"]');
    if (existingForm) existingForm.remove();

    const form = document.createElement('form');
    form.method = 'post';
    form.name = 'cart_form_ori';
    form.action = 'https://basket.step.rakuten.co.jp/rms/mall/bs/cartadd/set';
    form.acceptCharset = 'EUC-JP';
    form.target = '_blank';

    [
      { name: 'shop_bid', value: SHOP_BID },
      { name: 'item_id', value: itemConfig.itemId },
      { name: 'variant_id', value: itemConfig.variantId },
      { name: 'units', value: units },
      { name: 'choice', value: encodedChoice }
    ].forEach(function (d) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = d.name;
      input.value = d.value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    return false;
  }

  window.jump = function jump() {
    const $msg = $orderMsg();
    $msg.empty();

    const shape = getShape();
    const sizeErrors = buildJumpSizeErrors();
    const colorName = getSelectedColorName();
    const materialType = getSelectedMaterialType();
    const band = getBandByColor();

    if ($('#op_hole').prop('checked')) {
      const posVal = $('select[name="op_hole--position"]').val() || '';
      if (!posVal || posVal === '穴位置を選択') {
        sizeErrors.push('配線穴の位置を選択してください');
      }
    }

    if (sizeErrors.length) {
      sizeErrors.forEach(function (t) {
        $msg.append($('<p class="note-submit-error">').text(t));
      });
      setCheckoutUIEnabled(false);
      $('.check_price').empty().attr('style', 'visibility: hidden');
      $('#units').val('');
      return false;
    }

    if (!colorName || !materialType || !band) {
      $msg.append($('<p class="note-submit-error">').text('カラーを選択してください'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty().attr('style', 'visibility: hidden');
      $('#units').val('');
      return false;
    }

    if (!Array.isArray(priceTable) || !priceTable.length) {
      $msg.append($('<p class="note-submit-error">').text('価格表の読み込みに失敗しました'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty().attr('style', 'visibility: hidden');
      $('#units').val('');
      return false;
    }

    const haba = readInt('haba').val;
    const depth = shape === 'cir' ? haba : readInt('depth').val;
    const basePrice = getPriceCell(haba, depth, band);

    if (!Number.isFinite(basePrice)) {
      $msg.append($('<p class="note-submit-error">').text('価格が見つかりませんでした'));
      setCheckoutUIEnabled(false);
      $('.check_price').empty().attr('style', 'visibility: hidden');
      $('#units').val('');
      return false;
    }

    const existingCode = findExistingCode({
      shape: shape,
      haba: haba,
      depth: depth,
      colorKey: getColorKeyForExisting()
    });

    if (existingCode) {
      $msg.append(
        '<p class="existing-link">' +
          '<a href="' + EXISTING_URL + existingCode + '" target="_blank">' +
            '→既製品ページがございます。こちらのページよりお買い求めください。' +
          '</a>' +
        '</p>'
      );
      $('.check_price').empty().attr('style', 'visibility: hidden');
      setCheckoutUIEnabled(false);
      $('#units').val('');
      return false;
    }

    let price = basePrice;
    if ($('#op_haisen').prop('checked')) price += 1000;
    if ($('#op_hole').prop('checked')) price += 1000;

    const spans = document.querySelectorAll('.check_area ul li span');
    if (spans.length >= 5) {
      spans[0].textContent = getShapeText();
      spans[1].textContent = haba;
      spans[2].textContent = depth;
      spans[3].textContent = colorName;
      spans[4].textContent = getOptionText();
    }

    setChoiceValues({
      shapeText: getShapeText(),
      haba: haba,
      depth: depth,
      colorName: colorName,
      optionText: getOptionText(),
      price: price
    });

    $('.check_price').text(formatYen(price)).attr('style', '');
    $msg.append('<p class="note-submit-ok">以下の内容を確認し、買い物かごにお進みください。</p>');
    setCheckoutUIEnabled(true);
    return false;
  };

  $(function () {
    loadPriceOnce();
    loadExistingOnce();
    bindResizeAfterLoad();

    $('.aino-material').hide();
    $('.op_hole-area').hide();

    syncShapeInfo();
    updateHoleUI();
    syncAinoVisibility();
    syncMaterialBubble();
    updatePreviewImages();
    resizeFormSizeImages();
    resetOrderSummary();

    $(window).on('resize pageshow', function () {
      resizeFormSizeImages();
    });

    $(document).on('change', 'input[name="shape"]', function () {
      syncShapeInfo();
      filterColorSlidesByShape();
      updateHoleUI();
      updatePreviewImages();
      validateSizeFieldForBlur('haba');
      validateSizeFieldForBlur('depth');

      const shape = getShape();

      if (shape === 'cir') {
        // 非表示
        $('#op_haisen').closest('li').hide();

        // チェック解除
        if ($('#op_haisen').prop('checked')) {
          $('#op_haisen').prop('checked', false).trigger('change');
        }

        // 操作不可
        $('#op_haisen').prop('disabled', true);
      } else {
        // 表示戻す
        $('#op_haisen').closest('li').show();

        // 操作可能に戻す
        $('#op_haisen').prop('disabled', false);
      }
    });

    $(document).on('change', 'input[name="colortype1"]', function () {
      if (!this.checked) return;
      syncAinoVisibility();
      syncMaterialBubble();
      updatePreviewImages();
      updateHoleUI();

      // ▼追加ここから
      if (getSelectedMaterialType() === 'aino') {
        $('#op_haisen')
          .removeClass('osaka')
          .addClass('fukui');
      } else {
        $('#op_haisen')
          .removeClass('fukui')
          .addClass('osaka');
      }
      // ▲追加ここまで

      const colorId = this.id;

      // デフォルトに戻す
      $('#premium').prop('disabled', false);
      $('label[for="premium"] span').html('メラミン');

      // オレンジだけ制御
      /*if (colorId === 'aino_por') {
        $('#premium').prop('disabled', true);
        $('label[for="premium"] span').html('メラミン<br>（廃盤）');

        // premiumが選択されていた場合はreasonableへ戻す
        if ($('#premium').prop('checked')) {
          $('#reasonable').prop('checked', true).trigger('change');
        }
      }*/
    });

    $(document).on('change', '#reasonable, #premium', function () {
      syncMaterialBubble();
    });

    $(document).on('change', '#op_hole', function () {
      updateHoleUI();
    });

    $(document).on('input', '#haba, #depth', function () {
      const cleaned = onlyDigits(this.value);
      if (this.value !== cleaned) this.value = cleaned;
    });

    $(document).on('blur', '#haba, #depth', function () {
      validateSizeFieldForBlur(this.id);
    });

    $('form[name="frm_detail"]').on('change input', 'input, select, textarea', function () {
      const $t = $(this);
      if ($t.is('#units, #choice1, #choice2, #choice3, #choice4, #choice5, #choice6, #choice7')) return;
      resetOrderSummary();
    });

    $(document).on('click', '#modal-cart', function (e) {
      submitToRakutenCart(e);
    });

    $(document).on('click', '.btn-cart, .cartadd', function (e) {
      submitToRakutenCart(e);
    });

    $(document).on('submit', 'form[name="frm_detail"]', function (e) {
      submitToRakutenCart(e);
    });

    $(document).on('submit', 'form[name="frm"]', function (e) {
      submitToRakutenCart(e);
    });

    setTimeout(function () {
      filterColorSlidesByShape();
      syncAinoVisibility();
      syncMaterialBubble();
      updatePreviewImages();
    }, 0);
  });

})(jQuery);
